import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { Button } from "../../components/Buttons";
import { Circle } from "../../components/Animation";
import { H2 } from "../../components/Text";
import { validateArray } from "../../utils/validate";
import { requestAuth } from "../../components/services/RequestService";
import ListInCharge from "../../containers/ModalsCompany/ListInCharge";
import { useState } from "react";
import { Request } from "../../hooks/Request";

const NewProcedure = (props) => {
  const { reload, onClose, openModal, isQuotation = false } = props;

  function handleInCharge(values) {
    openModal(<ManageInCharge values={values} {...props} />);
  }
  const [load, setload] = useState(false);
  async function handleRegister(values) {
    setload(true);
    await requestAuth("post", isQuotation ? `/procedure/simple` : `/procedure`, values)
      .then(() => {
        // setload(false);
        reload();
        onClose();
        toast.success("Trámite agregado correctamente!!!");
      })
      .catch((error) => {
        setload(false);
        toast.error(error?.response?.data ?? "Se ha producido un error al crear el Proceso");
      });
  }

  return (
    <div>
      <FormDefault
        tittle="Agregar nuevo trámite"
        fields={[
          {
            label: "Compañia",
            name: "CompanyId",
            typeInput: "select",
            urlApi: "/company/getallcompanies",
            value: "id",
            labelOption: "razonSocial",
          },
          {
            label: "Tipo de procedimiento",
            name: "ProcedureTypeId",
            typeInput: "select",
            urlApi: "/procedureType",
            value: "id",
            labelOption: "name",
          },
          // {
          //   label: "Aduana de despacho",
          //   name: "custom",
          //   typeInput: "select",
          //   urlApi: "Dropdown/listaAduanas/options",
          //   value: "name",
          //   labelOption: "name",
          // },
          // {
          //   label: "Año",
          //   name: "year",
          //   type: "text",
          //   typeInput: "text",
          // },
        ]}
        initialValues={{
          CompanyId: "",
          ProcedureTypeId: "",
          IsQuotation: isQuotation,
          year: new Date().getFullYear().toString(),
        }}
        validationSchema={Yup.object().shape({
          CompanyId: Yup.string().required("Este campo es obligatorio"),
          ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
        })}
        onSubmit={handleRegister}
        buttonName="Guardar"
      />
    </div>
  );
};

const ManageInCharge = (props) => {
  const { reload, onClose, values, isQuotation } = props;
  const { data, loading, call } = Request({
    urlApi: `/company/${values.CompanyId}/inChargeCompany`,
  });
  const [load, setload] = useState(false);
  async function handleRegister() {
    setload(true);
    await requestAuth("post", isQuotation ? `/procedure/simple` : `/procedure`, values)
      .then(() => {
        setload(false);
        reload();
        onClose();
        toast.success("Trámite agregado correctamente!!!");
      })
      .catch(() => {
        setload(false);
        toast.error("Se ha producido un error al crear el Proceso");
      });
  }
  return (
    <div>
      <H2>Encargados del Cliente</H2>
      <ListInCharge company={{ id: values.CompanyId }} reloadList={call} />
      {load && loading ? (
        <Circle />
      ) : (
        <Button
          onClick={handleRegister}
          disabled={!validateArray(data)}
          className={`py-4 w-full`}
        >
          Registrar
        </Button>
      )}
    </div>
  );
};

export default NewProcedure
